export const AUTHOR_ZAUFANE_PL = 'zaufane.pl';
